<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <!-- Success Message -->
    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}

    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}

    </div>

    <!-- TITLE -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">

        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                Popular Destination Category Management
            </h2>

            <p class="text-sm text-slate-500 mt-1">
                Configure website locales and translations.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">

            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add</span>

        </button>

    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-6">

        <!-- Dynamic Languages -->
        <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
            [class.text-primary]="activeTab === lang.code" [class.border-primary]="activeTab === lang.code">

            <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">

            {{ lang.name }} ({{ getLanguageCount(lang.code) }})

        </button>

    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterPopularDestinationCategories(activeTab)"
            placeholder="Search categories"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">

        <div class="overflow-x-auto">

            <table class="w-full text-left border-collapse">

                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Category Name
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Parent Category
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Language
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Enable
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right"
                            style="width:150px">
                            Actions
                        </th>

                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">

                    <tr *ngFor="let obj of pagedCategories" class="hover:bg-slate-50 transition-colors">

                        <!-- Category Name -->
                        <td class="px-3.5 py-4.5 font-semibold text-slate-900">
                            {{ obj.name }}
                        </td>

                        <!-- Parent Category -->
                        <td class="px-3.5 py-4.5 text-slate-600">
                            {{ obj.parentName || '-' }}
                        </td>

                        <!-- Language -->
                        <td class="px-3.5 py-2.5 col-width">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.languageCode }}
                            </span>
                        </td>

                        <!-- Enable -->
                        <td class="px-3.5 py-2.5 font-semibold text-slate-100 col-width">
                            <div class="flex cursor-pointer">
                                <!-- Switch Track -->
                                <span class="relative inline-block w-10 h-5 rounded-full transition-colors duration-300"
                                    [ngClass]="obj.isEnabled === true ? 'bg-green-500' : 'bg-gray-300'">
                                    <!-- Switch Knob -->
                                    <span
                                        class="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-300"
                                        [ngStyle]="{'transform': obj.isEnabled === true ? 'translateX(100%)' : 'translateX(0)'}">
                                    </span>
                                </span>

                                <!-- Status Text -->
                                <span class="px-2 py-1 text-xs text-slate-600">
                                    {{ obj.isEnabled === true ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                        </td>

                        <!-- Actions -->
                        <td class="px-3.5 py-2.5 text-right col-width">
                            <div class="flex justify-end gap-2">
                                <button class="p-1.5 text-slate-400 hover:text-primary"
                                    (click)="viewData(obj.popularDestinationCategoryId,'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>

                                <button class="p-1.5 text-slate-400 hover:text-red-500"
                                    (click)="viewData(obj.popularDestinationCategoryId,'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>

                    </tr>

                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="5">
                            <div class="flex justify-center mt-6 mb-6 gap-2">
                                <!-- more vertical spacing and slightly bigger gap -->
                                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                                    (click)="changePage(i + 1)"
                                    [ngClass]="currentPage === (i+1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                                    class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                                    {{ i + 1 }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tfoot>

            </table>

        </div>

    </div>

</main>

<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div class="bg-white w-[625px] rounded-xl shadow-xl">

        <!-- Header -->
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">

            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">admin_panel_settings</span>
                    Add New Popular Destinations Category
                </h3>

                <p class="text-sm text-slate-500 mt-0.5">
                    Define and configure a new popular destinations category for the portal.
                </p>
            </div>

            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>

        </div>

        <!-- Body -->
        <div class="p-5 space-y-4">

            <div class="mt-2">

                <div class="mb-5">
                    <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Parent Category
                    </label>

                    <select [(ngModel)]="parentCategoryId" name="parentCategoryId"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none">
                        <option [ngValue]="null">No parent category</option>
                        <option *ngFor="let category of getParentCategoryOptions()" [ngValue]="category.categoryId">
                            {{ getCategoryLabel(category) }}
                        </option>
                    </select>
                </div>

                <div>
                    <!-- <label class="block mb-1 text-sm font-semibold text-gray-700">
                        Status
                    </label> -->

                    <div class="flex items-center gap-4 mt-1">
                        <!-- Active -->
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input type="radio" [(ngModel)]="isEnabled" name="status" [value]="true"
                                class="w-4 h-4 text-primary border-gray-300 focus:ring-2 focus:ring-primary">
                            <span class="text-sm text-gray-700">Active</span>
                        </label>

                        <!-- Inactive -->
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input type="radio" [(ngModel)]="isEnabled" name="status" [value]="false"
                                class="w-4 h-4 text-primary border-gray-300 focus:ring-2 focus:ring-primary">
                            <span class="text-sm text-gray-700">Inactive</span>
                        </label>
                    </div>
                </div>

                <!-- Language Tabs -->
                <div class="flex border-b border-slate-200 mb-4 gap-6 mt-7">

                    <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
                        class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
                        [class.text-primary]="activeTabPopup === lang.languageId"
                        [class.border-primary]="activeTabPopup === lang.languageId">

                        <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">

                        {{ lang.name }}

                    </button>

                </div>

                <form enctype="multipart/form-data" class="space-y-4">

                    <div *ngIf="activeTabPopup === 1">
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Name
                            </label>

                            <input type="text" [(ngModel)]="nameKh" name="nameKh" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter category name in Khmer" />
                        </div>

                    </div>

                    <div *ngIf="activeTabPopup === 2">
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Name
                            </label>

                            <input type="text" [(ngModel)]="nameEn" name="nameEn" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter category name in English" />
                        </div>

                    </div>

                </form>

            </div>

        </div>

        <!-- Footer -->
        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">

            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>

            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>

            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>

        </div>

    </div>
</div>
